// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__rjXksq8YTR{width:745px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/copilotTrialOutroModal/copilotTrialOutroModal.module.scss"],"names":[],"mappings":"AAEA,mBACE,WAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.modal {\n  width: 745px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__rjXksq8YTR`
};
export default ___CSS_LOADER_EXPORT___;
